document.documentElement.classList.remove('no-js');

const menuButton = document.querySelector('[data-menu-toggle]');
const menu = document.querySelector('[data-mobile-menu]');

if (menuButton && menu) {
  menuButton.addEventListener('click', () => {
    const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!isOpen));
    menuButton.querySelector('.sr-only').textContent = isOpen ? 'Open menu' : 'Close menu';
    menu.hidden = isOpen;
    if (!isOpen) menu.querySelector('a, summary, input, button')?.focus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !menu.hidden) {
      menu.hidden = true;
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.focus();
    }
    if (event.key === 'Tab' && !menu.hidden) {
      const focusable = [...menu.querySelectorAll('a, summary, input, button')].filter((node) => !node.disabled);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
}

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.quick-add');
  if (!form || !window.fetch) return;
  event.preventDefault();
  const button = form.querySelector('button');
  button.disabled = true;
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
    });
    if (!response.ok) throw new Error('Could not add this item.');
    const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((res) => res.json());
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    button.textContent = 'Added ♥';
  } catch (error) {
    button.textContent = error.message;
  } finally {
    setTimeout(() => { button.disabled = false; button.textContent = 'Quick add'; }, 1800);
  }
});
